/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TagListItemViewModelPaginatedResponse } from "../types/TagListItemViewModelPaginatedResponse.ts";
import { tagListItemViewModelSchema } from "./tagListItemViewModelSchema.ts";

export const tagListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => tagListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<TagListItemViewModelPaginatedResponse>;
